<cache-date></cache-date>

<period></period>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<div class="row">
	<div class="col-md-12">
		<chart [data]="chart.data" [options]="chart.options" [sextant]="'chart'" [url]="filter.currentUrl"></chart>
	</div>
</div>

<hr><br>

{{ 'adminstat.site.widget search.search сount' | translate }}: {{ searchCount }}
<br>
{{ 'adminstat.site.widget search.user сount' | translate }}: {{ userCount }}
<br>

<br>
<loading [isLoad]="paginationLoader"></loading>
<ngb-pagination
	*ngIf="pagination.pageCount"
	[collectionSize]="pagination.pageCount"
	[maxSize]="10"
	[pageSize]="1"
	[(page)]="pagination.page"
	[boundaryLinks]="true"
	(pageChange)="onPageChange()"
></ngb-pagination>

<br>
<loading [isLoad]="statsLoader"></loading>
<table class="table" *ngIf="!statsLoader && stats.length > 0" [sextant]="'table'" [url]="filter.currentUrl">
	<thead>
		<th>{{ 'adminstat.template.search phrase' | translate }}</th>	
		<th>{{ 'adminstat.site.widget search.search сount' | translate }}</th>	
		<th>{{ 'adminstat.site.widget search.user сount' | translate }}</th>	
		<th>{{ 'adminstat.template.tag.success' | translate }}</th>	
	</thead>
	
	<tbody>
		<tr *ngFor="let stat of stats" [class]="stat.results.length == 0 ? 'table-danger' : 'table-default'">
			<td [title]="stat.query">
				"{{ stat.query.length > 100 ? stat.query.substr(0, 100) : stat.query }}"
			</td>

			<td>
				{{ stat.searchCount }}
			</td>
	
			<td>
				{{ stat.userCount }}
			</td>
			
			<td>
				<ul *ngIf="stat.results.length > 0">
					<li *ngFor="let widget of stat.results">
						{{ widget }}
					</li>
				</ul>
			</td>
		</tr>
	</tbody>
</table>
